import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import axiosInstance from "../../../api/axiosInstance";
import endpoints from "../../../api/endpoints";

export interface Client {
  NumeroClient: string;
  RaisonSociale: string;
  etat: string;
  Adresse: string;
  Tel: string;
}

interface ClientState {
  clients: Client[];
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  numClient: string;
}

const initialState: ClientState = {
  clients: [],
  status: "idle",
  error: null,
  numClient: "",
};

export const fetchClients = createAsyncThunk(
  "clients/fetchClients",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        endpoints.clients.clientsBySalesRepresentative
      );

      return response.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des clients:", error);
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.response?.data || "Network error");
      }
      return rejectWithValue("An unknown error occurred");
    }
  }
);

const listClientSlice = createSlice({
  name: "clients",
  initialState,
  reducers: {
    saveClientNum(state, action: PayloadAction<string>) {
      state.numClient = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchClients.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.clients = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const { saveClientNum } = listClientSlice.actions;

export default listClientSlice.reducer;
